
<ion-content>
<ion-card class="ion-padding">
  <ion-item lines="none" class="ion-text-center ion-padding">
    <ion-label>
      <h1><strong>{{ 'YOU_ARE_REGISTERED' | translate }}</strong></h1>
    </ion-label>
  </ion-item>

  <img *ngIf="updater" [src]="registration?.imageLink" />

  <ion-grid class="ion-margin-bottom">
    <ion-row>
      <ion-col size="3" class="ion-text-center">
        <ion-button
          expand="block"
          [style.backgroundColor]="color"
          [style.--background]="color"
          [disabled]="startDisabled"
          (click)="onDismiss(0)"
          size="small"
        >
          <ion-icon name="play" slot="start" style="margin-right: 8px;"></ion-icon>
          {{ 'NEARBY_MODIFY_START_START' | translate }}
        </ion-button>
      </ion-col>

      <ion-col size="6">
        <!-- Uncomment if needed -->
        <!--
        <ion-button
          *ngIf="!noAddResultButton"
          expand="block"
          [style.backgroundColor]="color"
          [disabled]="startDisabled"
          (click)="onDismiss(1)"
          size="small"
        >
          <ion-icon name="create" slot="start"></ion-icon>
          {{ 'ADD_RESULT' | translate }}
        </ion-button>
        -->
        <div style="height: 33px;"></div>
      </ion-col>

      <ion-col size="2" class="ion-text-right ion-text-center">
        <ion-button fill="clear" (click)="onPostFB()" size="small">
          <ion-icon name="logo-facebook" [style.color]="color" class="static-logo"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="1" class="ion-text-right ion-text-center">
        <ion-button fill="clear" (click)="onPostInstagram()" size="small" style="margin-left: -2px;">
          <ion-icon name="logo-instagram" [style.color]="color" class="static-logo"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
<ion-fab vertical="top" horizontal="end" slot="fixed" style="top: 35%; padding: 5px;">
    <ion-fab-button  (click)="onDismiss(-1)">
      <ion-icon name="close" size="large"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
